import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/reservations";
const ReservationApi = {
  reservations(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
};

export default ReservationApi;
